import { render, staticRenderFns } from "./ManuallyBackupData.vue?vue&type=template&id=221dfe40&scoped=true&"
import script from "./ManuallyBackupData.vue?vue&type=script&lang=js&"
export * from "./ManuallyBackupData.vue?vue&type=script&lang=js&"
import style0 from "./ManuallyBackupData.vue?vue&type=style&index=0&id=221dfe40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221dfe40",
  null
  
)

export default component.exports